<template>
  <div style="position:relative">
    <Title title="九吨新闻"></Title>
    <div class="page6-box">
      <div class=" swiper6">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in list" :key="index">
            <img :src="item.resource" class="img" alt="" @click="lookBig(item)">
            <div class="text-box">
              <h1 class="title">{{ item.title }}</h1>
              <p class="desc">{{ item.subTitle }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="cutover ajc space-between">
        <div class="left ajc" @click="less" v-if="current != 0">
          <img src="@/assets/img/mobile/20.png" class="right-icon" alt="">
        </div>
        <div v-else class="ajc">
          <img src="@/assets/img/mobile/18.png" class="right-icon" alt="">
        </div>
        <div class="number"><span>{{ current + 1 }}</span> / {{ list.length }}</div>
        <div class="right ajc" @click="add" v-if="current + 1 < list.length">
          <img src="@/assets/img/mobile/21.png" class="right-icon" alt="">
        </div>
        <div v-else class="ajc">
          <img src="@/assets/img/mobile/19.png" class="right-icon" alt="">
        </div>
      </div>
    </div>

    <!-- 大图 -->
    <div class="bigImg ac" v-if="bigShow" @click="bigShow = false">
      <div>
        <img :src="currentImg" alt="" class="img" @click.stop="">
        <img src="@/assets/img/mobile/24.png" class="close-icon" alt="" @click="bigShow = false">
      </div>
    </div>

  </div>
</template>

<script>
import "swiper/js/swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      currentImg: "",
      bigShow:false, // 查看大图
      swiperExa: null, // swiper 实例
      current: 0,
      list: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    lookBig(item) {
      this.currentImg = item.extends.big_pic
      this.bigShow = true
    },
    async getData() {
      const [err, res] = await this.$http.get('news')
      if (err) return
      this.list = res.list
      this.$nextTick(() => {
        this.initSwiper();
      })
    },
    less() {
      if (this.current > 0) {
        this.current -= 1
        this.swiperExa.slideToLoop(this.current)
      }
    },
    add() {
      if (this.current + 1 < this.list.length) {
        this.current += 1
        this.swiperExa.slideToLoop(this.current)
      }

    },
    initSwiper() {
      const _this = this
      this.swiperExa = new Swiper(".swiper6", {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesOffsetAfter: 50,
        width: 500,
        // maxBackfaceHiddenSlides: 2,
        // direction: "vertical", // 垂直切换选项
        loop: true,
        loopAdditionalSlides: 1,
        on: {
          // 当轮播切换的时候
          slideChange: function () {
            _this.current = this.realIndex
          },
        }
      });
    }
  }

}
</script>

<style scoped lang="less">
.page6-box {
  margin-top: 2.5867rem;
  // overflow: hidden;
  // border: 1px solid;

  .swiper-slide {
    height: 4.2667rem;
    // width: 5.76rem !important;
    // border: 1px solid red;
    // margin-right: -20% ;

    .img {
      width: 100% !important;
      height: 3.0933rem;
      border-radius: .2667rem;
      margin-bottom: .1333rem;
      object-fit: cover;
      display: block;
    }

    .text-box {
      padding-left: .2133rem;
      box-sizing: border-box;
    }

    .title {
      font-size: .3733rem !important;
      margin-bottom: .2rem;
    }

    .desc {
      color: #666;
      font-size: .32rem;
    }
  }
}

.cutover {
  width: 3.4rem;
  margin: 2.6667rem auto 0;

  .right-icon {
    width: .2667rem;
    height: .2667rem;
  }

  .number {
    font-weight: bold;

    span {
      font-size: .3733rem;
      color: #E28A2B;
    }
  }

  .right,
  .left {
    width: 0.9rem;
    height: 0.9rem;
    background: #E28B2B;
    box-shadow: 0 .1333rem .5333rem rgba(226, 139, 43, 0.5);
    border-radius: .6667rem;
    color: #FFF;
  }
}

.bigImg {
  width: 10rem;
  height: 100vh;
  position: absolute;
  left: -.5333rem;
  top: -1.76rem;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  padding: .5333rem;
  box-sizing: border-box;
  .img{
    z-index: 9999;
    position: relative;
    width: 100%;
    object-fit: contain;
    border-radius: .2rem;
  }
  .close-icon{
    width: .7rem;
    // height: .5333rem;
    // position: absolute;
    display: block;
    margin: .4rem auto;
  }
}
</style>